<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{'addons.links.editSuccess' | translate}}</h2>
    </div>
    <button mat-icon-button type="button" (click)="cancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form">
      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{'addons.links.name' | translate}}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="name" type="text" [placeholder]="'addons.links.namePlaceholder' | translate" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['name'])">{{'fieldRequired' | translate}}</mat-error>
        </mat-form-field>
      </div>

      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{'addons.links.url' | translate}}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="url" type="text" [placeholder]="'addons.links.urlPlaceholder' | translate" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['url'])">{{'fieldRequired' | translate}}</mat-error>
        </mat-form-field>
      </div>

      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{'addons.links.text' | translate}}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="text" type="text" [placeholder]="'addons.links.textPlaceholder' | translate" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['text'])">{{'fieldRequired' | translate}}</mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="cancel()" [disabled]="saving">{{'cancel' | translate}}</button>
    <button mat-raised-button color="primary" type="button" (click)="onSubmit()" [disabled]="saving">
      <mat-spinner *ngIf="saving" diameter="20" class="dc-btn-spinner"></mat-spinner>
      {{ saving ? ('saving' | translate) : ('save' | translate) }}
    </button>
  </footer>
</div>
